import {
  BookingCriteria,
  BookingListItem,
  BookingTopUnit
} from "../../data-access/api-booking/Booking";
import {Injectable} from "@angular/core";
import {Store, StoreConfig} from "@datorama/akita";

export const BOOKING_DEFAULT_PAGE_SIZE: number = 20;
export const BOOKING_DEFAULT_SORT: string = 'dateUpd,desc';

export function createInitialBookingCriteria(): BookingCriteria {
  return {
    term: '',
    status: null,
    residenceId: null,
    page: 0,
    size: BOOKING_DEFAULT_PAGE_SIZE,
    sort: BOOKING_DEFAULT_SORT,
  };
}

export interface BookingData {
  /** Page courante de la liste uniquement — recherche, tri et pagination sont serveur. */
  bookings: BookingListItem[];
  /** Classement des logements, agrégé par le serveur sur l'ensemble des séjours. */
  topUnits: BookingTopUnit[];
  bookingCriteria: BookingCriteria;
  bookingTotalItems: number;
  bookingTotalPage: number;
  error?: unknown;
}

export type BookingState = BookingData;

function createInitialState(): BookingState {
  return {
    bookings: [],
    topUnits: [],
    bookingCriteria: createInitialBookingCriteria(),
    bookingTotalItems: 0,
    bookingTotalPage: 0,
    error: undefined,
  }
}

@Injectable({
  providedIn: 'root'
})
@StoreConfig({
  name: 'booking'
})
export class BookingStore extends Store<BookingState> {
  constructor() {
    super(createInitialState());
  }
}
